import styled from 'styled-components';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';

export const Container = styled.div`
  &.Wrapper{
    display: flex;
  }
  &.LeftBlock{
    width: 42%;
    display: none;
    @media screen and (min-width: 992px) {
      display: flex;
      flex-direction: column;
    }
  }
  &.RightBlock{
    width: 100%;
    @media screen and (min-width: 992px) {
      width: 58%;
    }
  }
  &.ImgAlign{
    display: flex;
    align-items: center;
    height: 115%;
  }
`;

export const StyledModalBtn = styled(Button)`
  &.FeedbackFooter{
    width: 162px;
    height: 50px;
    background: linear-gradient(90.82deg, #1CCCEF -33.3%, #1C62EF 84.24%);
    border-radius: 8px;
    border-width: 0;
    margin-top: 45px;
  
    &:hover{
      background: linear-gradient(90.82deg, #1CCCEF -33.3%, #1C62EF 84.24%);
      box-shadow: -8.49px -8.49px 5px rgba(255, 255, 255, 0.33), 8.17px 8.17px 12px rgba(36, 38, 89, 0.1);
      border-radius: 8px;
      border-width: 0;
    }
    &:focus{
      border-width: 0;
      background: linear-gradient(90.82deg, #1CCCEF -33.3%, #1C62EF 84.24%);
      box-shadow: inset 4px 4px 4px rgba(0, 0, 0, 0.15);
      border-radius: 8px;
    }
  }
  &.HeaderBtn{
    position: absolute;
    top: -14px;
    right: -12px;
    padding: 10px;
    background: #fff;
    border-radius: 100%;
    border-width: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background: radial-gradient(100% 100% at 0% 0%, rgba(221, 227, 250, 0.99) 0%, rgba(221, 229, 250, 0.4) 100%);
    &:hover{
      box-shadow: none;
      border-radius: 100%;
      border-width: 0;
    }
    &:focus{
      border-width: 0;
      box-shadow: inset 4px 4px 4px rgba(0, 0, 0, 0.15);
      border-radius: 100%;
    }
  }
`;

export const StyledH1 = styled.h1`
  font-family: Manrope, sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 36px;
  line-height: 135%;
  color: #2C2B48;
  margin-left: 37px;
`;

export const StyledH2 = styled.h2`
  font-family: Manrope, sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 150%;
  color: #2C2B48;
  &.modal-title {
    margin-top: 5px;
    margin-bottom: 45px;
  }
`;

export const StyledImg = styled.img`
  width: 100%;
`;

export const StyledFormLabel = styled(Form.Label)`
  font-family: OpenSans, sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  color: #2C2B48;
`;

export const StyledFormControl = styled(Form.Control)`
  color: #000;
  background: rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(10px);
  border-radius: 6px;
  border: 1px solid #ced4da;
  &:focus{
    background: rgba(255, 255, 255, 0.3);
    color: #000;
    box-shadow: none;
    border: 1px solid #ced4da;
  }
`;

export const StyledTextarea = styled.textarea`
  color: #000;
  background: rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(10px);
  border-radius: 6px;
  resize: none;
  width: 100%;
  height: 110px;
  border: 1px solid #ced4da;
  padding: 8px 12px;
  &:focus{
    box-shadow: none;
    outline: none;
  }
`;

export const StyledModalBody = styled(Modal.Body)`
  position: relative;
  padding: 29px;
`;

export const StyledModalFooter = styled(Modal.Footer)`
  padding-bottom: 68px;
  display: flex;
  justify-content: center;
  border-top: 0;
`;

export const ErrorText = styled.p`
  font-family: OpenSans, sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  color: red;
  margin-bottom: 10px;
`

export const AttitudeButton = styled(Button)`
  height: 32px;
  width: 32px;
  background-color: #ffffff;
  border: none;
  border-radius: 5px;
  text-align: center;
  padding: 2px 0;
  font-size: 18px;
  margin-right: 15px;
  display: flex;
  justify-content: center;
  &:focus, &:active, &:hover, &.active {
    background-color: #679CEFCC!important;
    border: none;
  }
  
`
